import { _TabEnabledMixin } from "../../../moreCore/_loadingHelpers/Tabbing";
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './communicationEditor.html?raw';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';

import emailForm from '../../EMail/emailForm';

class communicationEditor extends compose(_TabEnabledMixin) {
    templateString: any = template;

    private objID:string;
    private objClassname:string;
    private objClassprintname:string;

    private displayWidget: any | MdsLax<InstanceType<typeof emailForm>>;

    private mainContentContainer:HTMLDivElement;

    private flagHandleEmailEdgeCases = false;
    private flagEatFirstDirty = false;
    private flagDirty = false;

    private closeRequestDlg: MdsLax<InstanceType<typeof GenericDialog>>;

    constructor(ID:string, classname:string, classprintname:string) {
        super(...(arguments as unknown as []));
        this.objID = ID;
        this.objClassname = classname;
        this.objClassprintname = classprintname;
    }

    public init(tabcontainername?: string){
        //wir sollten saved emitten je nach option
        switch(this.objClassname){
            case 'email_transmission':
                let form = new emailForm();
                this.displayWidget = form;
                this.displayWidget.placeAt(this.mainContentContainer);
                
                form.setup(this.objID, { isHistoryContext: true });
                form.on("saveForm", lang.hitch(this, ()=>{
                    this.emit("saved");
                    this.emitDirty(false);
                    this.flagDirty = false;
                }));

                form.show("dlg", null, tabcontainername);
                this.flagHandleEmailEdgeCases = true;
                break;
            default:
                console.error("not yet implemented", this.objClassname);
                throw "classtype not yet implemented";
                return;
        }
        this.displayWidget.on("dirty", lang.hitch(this, this._HandleDirty));
    }

    private _HandleDirty(){
        if (this.flagHandleEmailEdgeCases == false){
            this.emit("dirty");
            this.emitDirty(true);
        }else{
            if (this.flagEatFirstDirty == false){
                this.flagEatFirstDirty = true;
                return;
            }
            this.emit("dirty");
            this.emitDirty(true);
        }
    }

    postCreate(): void {
        //da widgets wie emailFormStandalone evtl es nicht so moegen beim createn nicht im DOM zu sein, laden wir erst alles wenn wir uns selber im tab container aufmachen...
        this.on("dirty", lang.hitch(this, ()=>{
            this.flagDirty = true;
        }));
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    //public getTabConfig(): Tabbing.TabPageDescriptor {
    //    return {
    //        widget: this,
    //        enableClosing: true,
    //        name: "comEdit_" + this.objClassname + "_" + this.objID,
    //        label: this.objClassprintname + " " + this.translations["CommunicationHelper_Tab_Label"]
    //    };
    //}
    _onCloseRequest():boolean{
        if (this.flagDirty == true){
            this.closeRequestDlg = new GenericDialog();
            this.closeRequestDlg.show(
                this.translations["email_mailForm_popup_unsaved_Body_part1"], //es gibt ungespeicherte aenderungen, wollen sie wirklich....
                this.translations["email_mailForm_popup_unsaved_Header"] + "\n" + this.translations["email_mailForm_popup_unsaved_Body_part2"],
                null,
                "fas fa-exclamation-circle",
                'okcancel',
                lang.hitch(this, this._onHandle_TabCloseRequest)
            );
            return false;
        }
        return true;
    }

    private _onHandle_TabCloseRequest(res:number){
        if (res == 1){
            //"ok"
            this.closeTab();
            this.emit("closed");
        }
    }

    _onShow() {
        if (this.flagHandleEmailEdgeCases == true) {//damit der sc editor neu geladen wird
            try {
                this.displayWidget._onActivated();
            } catch (ex) {
                console.warn(this.id + " _onShow: _onActived of widget failed", ex);
            }
        }
    }
    _onActivated() {
        if (this.flagHandleEmailEdgeCases == true) {
            try {
                this.displayWidget._onActivated();
            } catch (ex) {
                console.warn(this.id + " _onActivated: _onActived of widget failed", ex);
            }
        }
    }
    _onHide() {
        if (this.flagHandleEmailEdgeCases == true) {
            try {
                this.displayWidget._onHide();
            } catch (ex) {
                console.warn(this.id + " _onShow: _onHide of widget failed", ex);
            }

        }
    }

}

export default mdsWidget(communicationEditor);

